import { render, staticRenderFns } from "./PasswordChanged.vue?vue&type=template&id=50ae0467&scoped=true&"
import script from "./PasswordChanged.vue?vue&type=script&lang=js&"
export * from "./PasswordChanged.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChanged.vue?vue&type=style&index=0&id=50ae0467&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae0467",
  null
  
)

export default component.exports